const events = {
  all: 'All',
  general: {
    search: 'Search Event',
    add: 'Add',
    assign: 'Assign',
    details: 'Event details',
    fetchError: 'Failed to fetch data',
  },
  selectors: {
    selector2: {
      access: 'Access',
      security: 'Security',
      alarms: 'Alarms',
      troubles: 'Troubles',
      lockdown: 'Lockdown',
      others: 'Others',
      cloud: 'Cloud',
    },
    selector3: {
      organization: 'Account',
      site: 'Site',
      controller: 'Controller',
      door: 'Door',
      accessLevel: 'Access Level',
      card: 'Credential',
      user: 'User',
      schedule: 'Schedule',
      holiday: 'Holiday',
      reader: 'Reader',
    },
  },
  table: {
    date_and_time: 'Date & Time',
    description: 'Description',
    object: 'Object',
    detail: 'Detail',
    info: 'Info',
    extraInfo: 'Extra Info',
    instigator: 'Instigator',
    event: 'Event',
    type: 'Type',
    id: 'ID',
    displayName: 'Display Name',
    module: 'Module',
    sequenceNumber: 'Sequence Number',
  },
};

export default events;
